<template>
  <div class="main-footer">
    <div class="footer">
      <div class="footer-fl">
        <div class="foot-flex">
          <div class="li">
            <img :src="font1" alt="" />
            <span>地址：山东省寿光市文圣东街与弥河西坝交叉口往南300米路东</span>
          </div>
          <div class="li">
            <img :src="font2" />
            <span>热线：0536- 5200700</span>
          </div>
          <div class="li">
            <img :src="font3" />
            <span>邮箱：qgsczlbzzx@wf.shandong.cn</span>
          </div>
        </div>
        <div class="foot-copy">
          <div class="foot-mid">
            <p @click="toLink" class="icp">
              ©2022 版权所有 全国蔬菜质量标准中心 鲁ICP备2022019648号-1
            </p>
            <!-- <img
              @click="toYingYeZhiZhao"
              class="foot-yingyezhizhao"
              src="../assets/images/yingyezhizhao.jpg"
            /> -->
          </div>
          <!-- <p>技术支持：<a href="http://www.univalsoft.com/" :style="{color:(tabIndex == 0?'#fff':'#666')}">山东环球软件股份有限公司</a></p> -->
        </div>
      </div>
      <div class="footer-fr">
        <div class="foot-wx">
          <img src="@/assets/images/wx3.jpg" />
          <p>甄选蔬菜公众号</p>
        </div>
        <div class="foot-wx">
          <img src="@/assets/images/wx2.png" />
          <p>信息服务平台</p>
        </div>
		<div class="foot-wx">
		  <img src="@/assets/images/wx1.jpg" />
		  <p>全国蔬菜质量<br>标准中心公众号</p>
		</div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useRouter } from "vue-router";
const router = useRouter();
defineProps({
  wxColor: {
    type: String,
    default: "#999",
  },
  textColor: {
    type: String,
    default: "#666",
  },
  font1: {
    type: String,
    default: require("../assets/images/foot1.png"),
  },
  font2: {
    type: String,
    default: require("../assets/images/foot2.png"),
  },
  font3: {
    type: String,
    default: require("../assets/images/foot3.png"),
  },
  tabIndex: {
    type: [String, Number],
    default: 0,
  },
});
const toYingYeZhiZhao = () => {
  // window.location.href = 'http://nongsheng365.com/yyzzxxgs/';
  // window.open('http://nongsheng365.com/yyzzxxgs/');
  // router.push({ name: "BusinessLicense" });
  let routeUrl = router.resolve({ name: "BusinessLicense" });
  window.open(routeUrl.href);
};
const toLink = () => {
  window.open("https://beian.miit.gov.cn/#/Integrated/index");
};
</script>

<style lang="scss" scoped>
.main-footer {
  .footer {
    display: flex;
    align-items: center;
    justify-content: space-between;

    margin: 0 280px;
    padding: 45px 0;

    border-top: 1px solid rgba(153, 153, 153, .2);

    font-size: 30px;
  }

  .foot-wx {
    margin-left: 50px;

    text-align: center;

    color: v-bind(wxColor);

    font-size: 26px;
    line-height: 1;
    img {
      display: block;

      width: 180px;
      height: 180px;
      margin: 0 auto 10px auto;
    }
  }

  .footer-fr {
    display: flex;
  }

  .footer-fl {
    text-align: left;

    color: v-bind(textColor);

    font-size: 26px;
    line-height: 2.5;

    .foot-mid {
      display: flex;
      align-items: center;
      justify-content: flex-start;

      .foot-yingyezhizhao {
        margin-left: 30px;

        cursor: pointer;
      }

      .icp {
        cursor: pointer;
      }
    }
  }

  .foot-flex {
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    .li {
      display: flex;
      align-items: center;

      margin-right: 40px;

      img {
        width: 36px;
        margin-right: 10px;
      }
    }
  }
}

</style>
